import { render } from "./Depersonalization.vue?vue&type=template&id=6b978401&scoped=true"
import script from "./Depersonalization.vue?vue&type=script&lang=js"
export * from "./Depersonalization.vue?vue&type=script&lang=js"

import "./Depersonalization.vue?vue&type=style&index=0&id=6b978401&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b978401"]])

export default __exports__